module.exports = __webpack_public_path__ + "media/bory-video.86ef604e.mp4";